import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { Button } from 'semantic-ui-react';


const mapStateToProps = ({ intl }) => {
  return {
    locale: intl.locale,
  };
};

const LoginActions = () => (
  <Button.Group size="mini">
    <Button
      basic
      as={Link}
      color="blue"
      to="/login"
    >
      <FormattedMessage
        id="login.signIn"
      />
    </Button>
    <Button
      basic
      as={Link}
      color="blue"
      to="/login/new"
    >
      <FormattedMessage
        id="login.signUp"
      />
    </Button>
  </Button.Group>
);

export default connect(mapStateToProps)(LoginActions);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/loginActions/LoginActions.js
 **/